import MultiSelect from "../../components/MultiSelect";
import { collection, collectionGQL } from '@appmaker/shopify/api';
import debounce from 'lodash/debounce';
import { useEffect, useState, useCallback } from "react";

const Collections = (props = {}) => {
    // gid://shopify/Collection/466029084990  gid://shopify/Collection/453695144254
    const { properties = {}, onChange, defaultValue } = props;
    const {
        isMulti = false
    } = properties
    const [options, setOptions] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(defaultValue || []);
    const [isLoadingSelected, setIsLoadingSelected] = useState(false);

    const getCollection = async (query, ids) => {
        try {
            const response = await collectionGQL({ search: query, ids });
            if (response) {
                return Promise.resolve(response)
            }
            return Promise.resolve([]);
        } catch (error) {
            return Promise.resolve([])
        }

    }
    const searchProduct = useCallback(debounce(async (query) => {
        const response = await getCollection(query && query.length !== 0 ? query : undefined);
        setOptions(response);
        setLoading(false)
    }, 500), [])
    const onSearch = (value) => {
        setLoading(true)
        searchProduct(value)
    }
    // Single effect to handle all initialization and defaultValue changes
    useEffect(() => {
        (async () => {
            if (!options.length) {
                setLoading(true);
            }
            
            // Always ensure we have the basic collections list first
            let currentOptions = options.length ? options : await getCollection();
            
            // If we have defaultValue items that aren't in the current options, fetch them
            if (defaultValue?.length > 0 && 
                !defaultValue.every(id => currentOptions.find(item => item.id === id))) {
                
                setIsLoadingSelected(true);
                const collectionIdData = await getCollection(undefined, defaultValue);
                
                // Merge and deduplicate
                const allOptions = [...currentOptions, ...collectionIdData];
                const uniqueOptions = allOptions.filter((item, index, arr) => 
                    arr.findIndex(t => t.id === item.id) === index
                );
                currentOptions = uniqueOptions;
                setIsLoadingSelected(false);
            }
            
            setOptions(currentOptions);
            setSelectedValue(defaultValue || []);
            setLoading(false);
        })();
    }, [defaultValue]); // Only re-run when defaultValue changes
    
    // Cleanup debounced function to prevent memory leaks
    useEffect(() => {
        return () => {
            searchProduct.cancel();
        };
    }, []);
    
    return <MultiSelect
        {...properties}
        value={selectedValue}
        loading={isLoading}
        loadingSelected={isLoadingSelected}
        onSearch={(value) => { onSearch(value) }}
        options={options}
        selectionType={isMulti ? 'checkbox' : 'radio'}
        onChange={(value) => {
            setSelectedValue(value);
            onChange(value);
        }}
        buttonText= "Select collection"
    />
}


export default Collections 